export function darkMode() {
  $('.toggle-darkmode').click(function(e){
    e.preventDefault();
    $('body').toggleClass('light')
    const isDark = !$('body').hasClass('light')
    if(isDark) {
      window.localStorage.removeItem('al_islight');
    } else {
      window.localStorage.setItem('al_islight', 1);
    }
    document.dispatchEvent(new CustomEvent('darkmode', {'detail': isDark }));
    $('.navigation__logos img').hide()
    setTimeout(function(){
      $('.navigation__logos img').show()
    }, 100);
  })
}

export function selectAutoWidth() {
  $('.select select').change(function(){
    var text = $(this).find('option:selected').text()
    var $aux = $('<select/>').append($('<option/>').text(text))
    $(this).after($aux)
    $(this).width($aux.width())
    $aux.remove()
  }).change()
}

export function fix100vw() {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth
  document.body.setProperty("--scrollbarWidth", `${scrollbarWidth}px`)
}

export function langSwith() {
  $('.lang-dropdown').click(function(e){
    $(this).addClass('open')
  })
}

export function beforeafter() {
  $('.box__images--beforeafter').each(function(){
    const $wrap = $(this)
    const $before = $wrap.find('.box__image:nth-child(2)')
    const $button = $wrap.find('.box__images__slider')
    const $input = $wrap.find('input')
    $input.on("input change", function(e){
      const sliderPos = e.target.value;
      $before.css('width', `${sliderPos}%`)
      $button.css('left', `${sliderPos}%`)
    });
  })
}

export function linkAnchors() {
  $('a[href^="#"]').click(function(e){
    const id = $(this).attr('href')
    if(id=="#" || id=="#contact") return;
    const $anchor = $(id)
    if($anchor.length) {
      e.preventDefault();
      const header = $('.header').outerHeight();
      $([document.documentElement, document.body]).animate({
        scrollTop: $anchor.offset().top - header - 100,
      }, 500);
    }
  })
}

export function notificationBell() {
  $('#onesignal-bell').click(function(e){
    e.preventDefault();
    $('.onesignal-bell-launcher-button').click()
  })
}
